var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound-container",on:{"click":_vm.logout}},[_c('el-card',{staticClass:"notfound-card"},[_c('img',{attrs:{"src":require("@/assets/shield_black.svg")}}),_c('h3',[_vm._v("Page Not Found")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }